import { GroupMember } from '@/modules/group/modules/groups/domain/models/GroupMembers'

import { axios, Response } from '../index'

const getGroupMembers = (groupId?: string): Response<GroupMember> => {
  return axios.get(`/v1/groups/${groupId}/members`)
}

export default getGroupMembers
